import { render, staticRenderFns } from "./BannerPrice.vue?vue&type=template&id=7a81682c&scoped=true"
import script from "./BannerPrice.vue?vue&type=script&lang=js"
export * from "./BannerPrice.vue?vue&type=script&lang=js"
import style0 from "./BannerPrice.vue?vue&type=style&index=0&id=7a81682c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a81682c",
  null
  
)

export default component.exports